import "./Slider.css";
import { Carousel } from "react-bootstrap";
import img1 from "./../../assets/1.png";
import img2 from "./../../assets/01.jpg";

const Slider = () => {
  return (
    <section className="Slider">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2>Testimonials</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Carousel>
              <Carousel.Item>
                <img src={img1} alt="First slide" />
                <Carousel.Caption>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Non
                    quod, in commodi esse, distinctio maiores, laudantium amet
                    laborum corporis possimus ullam mollitia hic fugiat
                    perspiciatis.
                  </p>
                  <h5>Web developer</h5>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img src={img2} alt="Second slide" />

                <Carousel.Caption>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Non
                    quod, in commodi esse, distinctio maiores, laudantium amet
                    laborum corporis possimus ullam mollitia hic fugiat
                    perspiciatis.
                  </p>
                  <h5>Back end developer</h5>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img src={img1} alt="Third slide" />

                <Carousel.Caption>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Non
                    quod, in commodi esse, distinctio maiores, laudantium amet
                    laborum corporis possimus ullam mollitia hic fugiat
                    perspiciatis.
                  </p>
                  <h5>Android developer</h5>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Slider;
